import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaxOnScreenHeightDirectiveSharedModule } from '@shared/core/directives/maxOnScreenHeight';
import { LoadersModule } from '@shared/core/components/loaders';
import { HintsPopupModule } from '@shared/core/components/hints/hintTypes/popup';

import { OrderAddVoucherComponent } from './order-add-voucher.shared.component';
import { IndicatorsModule } from '@shared/core/components/indicators';
import { LinkModule } from '@shared/core/components/link';
import { ButtonsModule } from '@shared/core/components/buttons';

@NgModule({
    declarations: [
        OrderAddVoucherComponent
    ],
    imports: [
        CommonModule,
        MaxOnScreenHeightDirectiveSharedModule,
        LoadersModule,
        HintsPopupModule,
        IndicatorsModule,
        LinkModule,
        ButtonsModule,
    ],
    exports: [
        OrderAddVoucherComponent
    ],
})
export class OrderAddVoucherModule { }
